import { createContext, useContext } from 'react'
import { Direction } from 'components/Animated/types'
import { CurrentUser } from 'customTypes'

interface NavigateToNextStepOptions {
  preserveSearch?: boolean
}

const defaultValues = {
  stepIndex: -1,
  navigateToNextStep: (_user?: CurrentUser | null, _options?: NavigateToNextStepOptions) => {},
  navigateToPreviousStep: () => {},
  registerCallback: (_cb: () => boolean) => {},
  direction: Direction.Forward,
  resetBackDirection: () => {}
}

export const VideoCallFlowContext = createContext(defaultValues)
export const useVideoCallsFlowContext = () => useContext(VideoCallFlowContext)
